import React, { useEffect, useRef, useState } from 'react'
import { dateToString } from '../../../utils/dateUtils'

const calculateTooltipPosition = (x, tooltipWidth, viewBoxWidth) => {
    // If viewBox data is not available, use default positioning
    if (!viewBoxWidth || !x) {
        return { transform: 'none', left: 0 }
    }

    const padding = 0 // Buffer from edges

    // Simple midpoint approach: if cursor is in the right half, show tooltip on left
    const isInRightHalf = x >= viewBoxWidth / 2

    // Calculate if tooltip would overflow on each side
    const wouldOverflowRight = x + tooltipWidth + padding > viewBoxWidth
    const wouldOverflowLeft = x - tooltipWidth - padding < 0

    // Determine positioning based on cursor position and overflow conditions
    if (isInRightHalf || wouldOverflowRight) {
        // Normal flip to left - move tooltip fully to the left of anchor
        return { transform: 'translateX(-108%)', left: 0 }
    }

    // Default: position tooltip to the RIGHT of the cursor (no transform needed)
    return { transform: 'none', left: 0 }
}

const ChartTooltip = ({
    active,
    payload,
    label,
    coordinate,
    roundValues = true,
    viewBox,
    isExpanded,
}) => {
    if (active) {
        const [top, setTop] = useState(0)
        const tooltipRef = useRef()

        useEffect(() => {
            if (tooltipRef && tooltipRef.current && active) {
                const gridBottom = viewBox.top + viewBox.height
                const yCoordinate = coordinate.y
                const tooltipHeight = tooltipRef.current.offsetHeight
                const tooltipBottom = tooltipHeight + yCoordinate
                if (tooltipBottom > gridBottom) {
                    const t = -Math.round(tooltipBottom - gridBottom)
                    setTop(t)
                } else {
                    setTop(0)
                }
            }
        }, [payload, active, viewBox, coordinate, tooltipRef])
        const formattedLabel = dateToString(label)

        // Use viewBox to determine positioning instead of window dimensions
        const tooltipWidth = 200 // Estimated tooltip width
        const positionStyle = calculateTooltipPosition(
            (coordinate && coordinate.x) || 0,
            tooltipWidth,
            (viewBox && viewBox.width) || 0
        )

        return (
            <div
                className="customTooltip"
                ref={tooltipRef}
                style={
                    isExpanded
                        ? { top, position: 'relative', ...positionStyle }
                        : { top, position: 'relative' }
                }
            >
                <p className="customTooltipLabel">{formattedLabel}</p>
                <ul className="customTooltipList">
                    {payload &&
                        payload.map((x, idx) =>
                            x.name !== 'NoTooltipItem' ? (
                                <li style={{ color: x.color }} key={idx}>
                                    <span className="customTooltipItemName">
                                        {x.name}
                                    </span>
                                    <span> : </span>
                                    <span className="customTooltipItemValue">
                                        {roundValues
                                            ? Math.round(x.value * 100) / 100
                                            : x.value}
                                    </span>
                                    <span className="customTooltipItemUnit">{` ${x.unit}`}</span>
                                </li>
                            ) : null
                        )}
                </ul>
            </div>
        )
    }
    return null
}

export default ChartTooltip
